import React from 'react';

const ErrorBoundary = () => {
  return (
    <div style={{ padding: '50px' }}>
      <h1>Sorry.. there was an error</h1>
      <p style={{ marginTop: '50px' }}>
        Пожалуйста{' '}
        <button
          style={{ color: 'blue' }}
          onClick={() => window?.location?.reload()}
        >
          перезагрузите страницу
        </button>{' '}
        или вернитесь{' '}
        <button
          style={{ color: 'blue' }}
          onClick={() => window?.history?.back()}
        >
          назад
        </button>
      </p>
    </div>
  );
};

export default ErrorBoundary;
